// Access refused by KYP staff: the whole client suspended, or this one account
// blocked. user-management answers 401 with one of these messages at sign-in
// and at token refresh; the sign-in page shows the message as it is.
// ⛔ Must match exception.ClientSuspendedMessage / AccountBlockedMessage in
// user-management.

export const CLIENT_SUSPENDED_MESSAGE =
  "Your organisation's account has been suspended. Please contact KYP support";
export const ACCOUNT_BLOCKED_MESSAGE =
  'Your account has been blocked. Please contact your administrator';

export type AccessRefusedReason = 'suspended' | 'blocked';

/** Which refusal a server message is, or null if it's something else. */
export function accessRefusedReason(message: string | undefined): AccessRefusedReason | null {
  if (message === CLIENT_SUSPENDED_MESSAGE) return 'suspended';
  if (message === ACCOUNT_BLOCKED_MESSAGE) return 'blocked';
  return null;
}

/** The message to show for a refusal reason. */
export function accessRefusedMessage(reason: AccessRefusedReason): string {
  return reason === 'suspended' ? CLIENT_SUSPENDED_MESSAGE : ACCOUNT_BLOCKED_MESSAGE;
}

/** The refusal message in a failed request, or null if it failed for another reason. */
export function accessRefusedError(e: unknown): string | null {
  // Duck-typed rather than isAxiosError: the shape is all that matters.
  const response = (e as { response?: { status?: number; data?: { message?: string } } } | null)
    ?.response;
  if (!response || response.status !== 401) return null;
  const message = response.data?.message;
  return message && accessRefusedReason(message) ? message : null;
}
